import FavoriteIcon from "@/icons/FavoriteIcon";
import useSnackBar from "@/hooks/useSnackBar";
import useWishList from "@/hooks/useWishList";

function AddToWishlistButton({ product }) {
	const { handleOpen } = useSnackBar();
	const { addToWishlist, removeFromWishlist, isInWishlist } = useWishList();

	function handleClick(event) {
		event.preventDefault();
		event.stopPropagation();
		if (isInWishlist(product)) {
			removeFromWishlist(product);
			return;
		}

		addToWishlist(product);
		handleOpen(`${product.name} was added to your Wishlist`, true);
	}

	return (
		<button onClick={handleClick} className={`${ isInWishlist(product) ? "favorited" : ""} btn-add-to-wishlist btn-reset`} title="Add item to Wishlist" aria-label="Add item to Wishlist">
			<FavoriteIcon />
		</button>
	);
}
export default AddToWishlistButton;